import React, { useState, useEffect } from 'react'
import MainLayout from '../../layout/MainLayout'
import Table from '../../components/Table'
import { api } from '../../api/axios'
import { tableDateFormate } from '../../utils/dateHelper'
import { toast } from 'react-toastify';
import { Download } from 'lucide-react';
import PaginationBar from '../../components/PaginationBar';
import { toCSV, download } from '../../utils/csv';

const tableHeadingdata = ["#", "Date", "User Name", "Mobile", "Package", "Amount", "PG", "Order ID", "Status", "Action"]

const STATUS_OPTIONS = ["CREATED", "SUCCESS", "FAILED", "PENDING", "CANCELLED", "REFUNDED"];

function Transactions() {
    const [transactions, setTransactions] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(0)
    const [totalPayments, setTotalPayments] = useState(0)
    const [loading, setLoading] = useState(false)
    const limit = 10

    useEffect(() => {
        fetchTransactions(currentPage)
    }, [currentPage])

    const fetchTransactions = async (page) => {
        try {
            setLoading(true)
            const response = await api.get(`/payments?page=${page}&limit=${limit}`)
            if (response.status === 200) {
                setTransactions(response.data.payments)
                setTotalPages(Number(response.data.totalPages))
                setCurrentPage(Number(response.data.currentPage))
                setTotalPayments(Number(response.data.totalPayments))
            }
        } catch (error) {
            console.error("Error fetching transactions:", error)
            toast.error("Failed to fetch transactions");
        } finally {
            setLoading(false)
        }
    }

    const handleStatusUpdate = async (id, newStatus) => {
        if (!window.confirm(`Are you sure you want to update status to ${newStatus}?`)) return;

        try {
            const response = await api.patch(`/payments/${id}/status`, { status: newStatus });
            if (response.status === 200) {
                toast.success("Payment status updated");
                fetchTransactions(currentPage); // Refresh data
            }
        } catch (error) {
            console.error("Error updating status:", error);
            toast.error("Failed to update status");
        }
    };

    const handleExportCSV = () => {
        if (!transactions || transactions.length === 0) {
            toast.info("Nothing to export on this page");
            return;
        }

        const rows = transactions.map((t) => ({
            date: t.createdAt ? new Date(t.createdAt).toISOString() : '',
            userName: t.userId?.name || '',
            mobile: t.userId?.mobile || '',
            package: t.packageId?.name || '',
            amount: t.amount ?? '',
            pg: t.pg || '',
            orderId: t.orderId || '',
            transactionId: t._id || '',
            packageId: t.packageId?._id || '',
            status: t.status || '',
        }));
        const headers = ["date", "userName", "mobile", "package", "amount", "pg", "orderId", "transactionId", "packageId", "status"];
        download(toCSV(rows, headers), `transactions-page-${currentPage}.csv`);
    }

    return (
        <MainLayout title="Transactions"
            Buttons={
                <button
                    onClick={handleExportCSV}
                    className="flex items-center gap-2 px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-md text-sm"
                >
                    <Download size={16} />
                    Export CSV
                </button>
            }
        >
            <div className="p-4">
                <Table tableHeadingdata={tableHeadingdata}>
                    {loading ? (
                        <tr>
                            <td colSpan={tableHeadingdata.length} className="text-center py-4">
                                Loading...
                            </td>
                        </tr>
                    ) : transactions.length > 0 ? (
                        transactions.map((item, index) => (
                            <tr className="bg-white border-b hover:bg-gray-100 text-gray-900" key={item._id}>
                                <th scope="row" className="px-6 py-4 font-medium whitespace-nowrap">
                                    {(currentPage - 1) * limit + index + 1}
                                </th>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {tableDateFormate(item.createdAt)}
                                </td>
                                <td className="px-6 py-4">
                                    {item.userId?.name || "N/A"}
                                </td>
                                <td className="px-6 py-4">
                                    {item.userId?.mobile || "N/A"}
                                </td>
                                <td className="px-6 py-4">
                                    {item.packageId?.name || "N/A"}
                                </td>
                                <td className="px-6 py-4 font-bold text-green-600">
                                    ₹{item.amount}
                                </td>
                                <td className="px-6 py-4">
                                    {item.pg}
                                </td>
                                <td className="px-6 py-4 text-xs">
                                    {item.orderId}
                                </td>
                                <td className={`px-6 py-4 font-semibold ${item.status === 'SUCCESS' ? 'text-green-600' : item.status === 'PENDING' ? 'text-yellow-600' : 'text-red-600'}`}>
                                    {item.status}
                                </td>
                                <td className="px-6 py-4">
                                    <select
                                        className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:border-blue-500"
                                        value={item.status}
                                        onChange={(e) => handleStatusUpdate(item._id, e.target.value)}
                                    >
                                        {STATUS_OPTIONS.map((status) => (
                                            <option key={status} value={status}>
                                                {status}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={tableHeadingdata.length} className="text-center py-4">
                                No transactions found.
                            </td>
                        </tr>
                    )}
                </Table>

                {/* Pagination Controls */}
                <div className="mt-4">
                    <PaginationBar
                        page={currentPage}
                        pageSize={limit}
                        totalItems={totalPayments}
                        totalPages={totalPages}
                        onChange={setCurrentPage}
                    />
                </div>
            </div>
        </MainLayout>
    )
}

export default Transactions